
import { Component, ViewChild } from '@angular/core';
import { NgbCollapseModule, NgbDateParserFormatter, NgbDatepickerModule, NgbDropdownModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../../Model/Common/common.service';
import { DashboardService } from '../../Model/Dashboard/dashboard.service';
import { UtilityService } from '../../Model/utility/utility.service';
import { CustomDateParserFormatter } from '../../Util/DateFormat/date-format.service';
import { SessionService } from '../../Util/Session/session.service';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { ChartConfiguration, Tooltip } from 'chart.js';
import moment from 'moment';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgChartsModule } from 'ng2-charts';
import * as XLSX from 'xlsx';
import { CardDetailComponent } from '../CardDetail/card-detail/card-detail.component';
import { CommonModule, DatePipe, DecimalPipe } from '@angular/common';
import { LoaderComponent } from '../../Component/Loader/loader/loader.component';
import { TooltipService } from '../../Util/Tooltip/tooltip.service';

@Component({
  selector: 'app-dashboard-back',
  standalone: true,
  imports: [CommonModule, NgChartsModule, DataTablesModule, FormsModule, NgbDatepickerModule, NgbDropdownModule, DecimalPipe, NgSelectModule, NgbCollapseModule, LoaderComponent],
  providers: [DatePipe,
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },],
  templateUrl: './dashboard-back.component.html',
  styleUrl: './dashboard-back.component.scss'
})
export class DashboardBackComponent {
  isDisabled: boolean = false;
  isApply: boolean = false;
  isGrouping: boolean = false;
  rowAttendanceData = [];
  rowAttendanceDataMain = [];
  rowAttendanceDataEmpMain = [];
  rowAttendanceDataEmp = [];
  filterData = [] as any;
  filterEmpData = [] as any;
  excelData = [] as any;
  dtTrigger: Subject<any> = new Subject<any>();
  dtTriggerEmp: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  @ViewChild(DataTableDirective, { static: false }) dtElementEmp!: DataTableDirective;

  dtOptions: DataTables.Settings = {
    pagingType: 'full_numbers',
    searching: true,
    pageLength: 25,
    lengthMenu: [10, 25, 50, 100],
    language: {
      searchPlaceholder: 'Search...',
    },
  };
  dtOptionsEmp: DataTables.Settings = {};

  Shifts = [] as any;
  States = [] as any;
  Regions = [] as any;
  Branchs = [] as any;
  Departments = [] as any;
  Designations = [] as any;

  HolidaysCal_1 = ['nh', 'ph'];//count 1
  LeaveCal_1 = ['cl', 'sl', 'pl'];//count 1
  LeaveCal_5 = ['hdcl/hd', 'hdcl/p', 'hdcl/a', 'hdsl/hd', 'hdsl/p', 'hdsl/a', 'hdpl/hd', 'hdpl/p', 'hdpl/a'];//count 0.5
  WeeklyOffCal_1 = ['w', 'wp', 'whd', 'wa', 'wo', 'wop', 'wohd', 'woa'];//count 1
  AbsentCal_1 = ['a', 'lmd'];//count 1
  AbsentCal_M1 = ['wp'];//count -1
  AbsentCal_M5 = ['whd'];//count -0.5
  AbsentCal_5 = ['hd', 'hdsl/a', 'hdcl/a', 'hdpl/a'];//count 0.5
  PresentCal_1 = ['p', 'wp'];//count 1
  PresentCal_5 = ['whd', 'hd', 'hdcl/hd', 'hdcl/p', 'hdsl/hd', 'hdsl/p', 'hdpl/hd', 'hdpl/p'];//count 0.5

  public BranchChartData: ChartConfiguration<'bar'>['data'] = {
    labels: [],
    datasets: [{
      data: []
    }],
  };

  public AttendanceChartData: ChartConfiguration<'bar'>['data'] = {
    labels: [],
    datasets: []
  };

  ChartLegend = {
    Attendance: true,
    Branch: true,
  }

  Collapsed = {
    BranchGraph: false,
    AttendanceGraph: false,
    AttendanceAnalytics: false,
    EmployeeDetails: false,
    SummaryDetails: false,
  }

  mfilter = {
    TodayDate: null as any,
    filterType: 3,
    FromDate: null as any,
    ToDate: null as any,
    YesterdateDate: null as any,
    ShiftMasterID: [],
    StateMasterID: [],
    RegionMasterID: [],
    BranchMasterID: [],
    DepartmentID: [],
    DesignationID: [],
    EmpDataLoad: false,
  }

  filter = {
    MonthYear: null as any,
    FromDate: null as any,//'01 Feb 2024' 
    ToDate: null as any,//'27 Feb 2024'
    UserId: null,
    Type: 'SiteWise'
  }

  Card = {
    Total: 0,
    Present: 0,
    PresentPer: 0 as any,
    Absent: 0,
    AbsentPer: 0 as any,
    WeeklyOff: 0,
    Leave: 0,
    Holiday: 0
  }

  groupby = {
    State: true,
    Region: true,
    Branch: true,
    Client: true,
    Site: true,
    Department: true,
    Designation: true,

    Checkall: true,
  }

  constructor(
    private dashboard: DashboardService,
    private utility: UtilityService,
    private dateFormate: CustomDateParserFormatter,
    public datepipe: DatePipe,
    private session: SessionService,
    private toast: ToastService,
    protected common: CommonService,
    private modalService: NgbModal,
    private tooltip: TooltipService,
  ) {
    this.common.getPageRights();
    this.common.CompanyParameter();
    this.common.CheckExpiry();
  }

  ngOnInit() {
    this.filter.UserId = this.session.GetUserDetails().UserId;
    this.SelectDate('RegistrationDate', null, null);
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
    this.dtTriggerEmp.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
    this.dtTriggerEmp.unsubscribe();
  }

  FetchData() {
    if (this.mfilter.filterType == 0 || this.mfilter.filterType == 3) {
      this.SelectDate('RegistrationDate', null, null);
    } else {
      this.ESS_AttendanceDashboardGetData();
    }
  }

  ESS_AttendanceDashboardGetData() {
    if (this.mfilter.filterType != 2 || (moment(this.dateFormate.format(this.mfilter.ToDate), 'DD MMM YYYY').isSameOrAfter(moment(this.dateFormate.format(this.mfilter.FromDate), 'DD MMM YYYY')))) {
      this.isDisabled = true;
      this.isApply = true;
      this.isGrouping = true;
      this.mfilter.EmpDataLoad = true;
      this.rowAttendanceData = [];
      this.rowAttendanceDataMain = [];
      this.filterData = [] as any;
      this.filterEmpData = [] as any;

      this.filterData = Object.values([]);
      try {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
          this.dtTriggerEmp.next(null);
        });
      } catch (e) { }

      if (this.mfilter.filterType == 0) {
        this.mfilter.FromDate = {
          "year": this.mfilter.TodayDate.year(),
          "month": this.mfilter.TodayDate.month() + 1,
          "day": this.mfilter.TodayDate.date()
        };
        this.mfilter.ToDate = {
          "year": this.mfilter.TodayDate.year(),
          "month": this.mfilter.TodayDate.month() + 1,
          "day": this.mfilter.TodayDate.date()
        };
      } else if (this.mfilter.filterType == 3) {
        this.mfilter.FromDate = {
          "year": this.mfilter.YesterdateDate.year(),
          "month": this.mfilter.YesterdateDate.month() + 1,
          "day": this.mfilter.YesterdateDate.date()
        };
        this.mfilter.ToDate = {
          "year": this.mfilter.YesterdateDate.year(),
          "month": this.mfilter.YesterdateDate.month() + 1,
          "day": this.mfilter.YesterdateDate.date()
        };
      }

      if (this.mfilter.filterType == 1) {
        this.filter.MonthYear = this.dateFormate.fullmonth[this.mfilter.FromDate.month - 1] + ' ' + this.mfilter.FromDate.year;
        this.filter.FromDate = null;
        this.filter.ToDate = null;
      } else if (this.mfilter.filterType == 0 || this.mfilter.filterType == 2 || this.mfilter.filterType == 3) {
        this.filter.MonthYear = null;
        this.filter.FromDate = this.dateFormate.format(this.mfilter.FromDate);
        this.filter.ToDate = this.dateFormate.format(this.mfilter.ToDate);
      } else if (this.mfilter.filterType == 4) {
        this.filter.MonthYear = null;
        this.filter.FromDate = this.dateFormate.format(this.mfilter.ToDate);
        this.filter.ToDate = this.dateFormate.format(this.mfilter.ToDate);
      }
      this.dashboard.ESS_AttendanceDashboardGetData({ MonthYear: this.filter.MonthYear, FromDate: this.filter.FromDate, ToDate: this.filter.ToDate, UserId: this.filter.UserId, Type: 'back' }).subscribe({
        next: (response) => {
          this.rowAttendanceDataMain = response.Table;
          this.rowAttendanceDataEmpMain = response.Table;
          this.Shifts = [];
          this.States = [];
          this.Branchs = [];
          this.Regions = [];
          this.Designations = [];
          this.Departments = [];

          [...new Set(this.rowAttendanceDataMain.map((item: any) => item.ShiftMasterID))].filter(e => e != null).forEach(element => {
            this.Shifts.push({
              ShiftMasterID: element,
              ShiftTitle: this.rowAttendanceDataMain.filter((e: any) => e.ShiftMasterID == element)[0]['ShiftTitle']
            })
          });

          [...new Set(this.rowAttendanceDataMain.map((item: any) => item.StateMasterId))].filter(e => e != null).forEach(element => {
            this.States.push({
              StateMasterID: element,
              StateName: this.rowAttendanceDataMain.filter((e: any) => e.StateMasterId == element)[0]['StateName']
            })
          });

          [...new Set(this.rowAttendanceDataMain.map((item: any) => item.RegionMasterID))].filter(e => e != null).forEach(element => {
            this.Regions.push({
              RegionMasterID: element,
              RegionName: this.rowAttendanceDataMain.filter((e: any) => e.RegionMasterID == element)[0]['RegionName']
            })
          });

          [...new Set(this.rowAttendanceDataMain.map((item: any) => item.BranchMasterID))].filter(e => e != null).forEach(element => {
            this.Branchs.push({
              BranchMasterID: element,
              BranchName: this.rowAttendanceDataMain.filter((e: any) => e.BranchMasterID == element)[0]['BranchName']
            })
          });

          [...new Set(this.rowAttendanceDataMain.map((item: any) => item.DesignationMasterID))].filter(e => e != null).forEach(element => {
            this.Designations.push({
              DesignationID: element,
              DesignationName: this.rowAttendanceDataMain.filter((e: any) => e.DesignationMasterID == element)[0]['DesignationName']
            })
          });

          [...new Set(this.rowAttendanceDataMain.map((item: any) => item.DepartmentMasterID))].filter(e => e != null).forEach(element => {
            this.Departments.push({
              DepartmentID: element,
              DepartmentName: this.rowAttendanceDataMain.filter((e: any) => e.DepartmentMasterID == element)[0]['DepartmentName']
            })
          });

          this.FilterFormBack();
          this.isDisabled = false;
        },
        complete: () => {
          this.isDisabled = false;
        },
        error: (error) => {
          this.isDisabled = false;
        },
      });
    } else {
      this.toast.show({ message: this.tooltip.Message.FromDateToDateMessgae, type: toastTypeEnum.danger });
    }
  }

  FilterFormBack() {
    try {
      this.isApply = true
      this.filterEmpData = [];
      //this.rowAttendanceData = this.rowAttendanceDataMain;
      this.rowAttendanceData = this.rowAttendanceDataMain.filter(e =>
        (this.mfilter.ShiftMasterID.length == 0 || this.mfilter.ShiftMasterID.indexOf(e['ShiftMasterID']) >= 0) &&
        (this.mfilter.StateMasterID.length == 0 || this.mfilter.StateMasterID.indexOf(e['StateMasterId']) >= 0) &&
        (this.mfilter.RegionMasterID.length == 0 || this.mfilter.RegionMasterID.indexOf(e['RegionMasterID']) >= 0) &&
        (this.mfilter.BranchMasterID.length == 0 || this.mfilter.BranchMasterID.indexOf(e['BranchMasterID']) >= 0) &&
        (this.mfilter.DesignationID.length == 0 || this.mfilter.DesignationID.indexOf(e['DesignationMasterID']) >= 0) &&
        (this.mfilter.DepartmentID.length == 0 || this.mfilter.DepartmentID.indexOf(e['DepartmentMasterID']) >= 0));

      this.Card.Total = this.rowAttendanceData.length;
      if (isNaN(this.Card.Total)) {
        this.Card.Total = 0;
      }

      this.Card.Present = (this.rowAttendanceData.filter((e: any) => this.PresentCal_1.indexOf(this.common.ToLowerCase(e.AttendanceRemark)) >= 0).length)
        + (this.rowAttendanceData.filter((e: any) => this.PresentCal_5.indexOf(this.common.ToLowerCase(e.AttendanceRemark)) >= 0).length / 2);
      this.Card.PresentPer = ((this.Card.Present * 100) / this.Card.Total).toFixed(2);
      if (isNaN(this.Card.PresentPer)) {
        this.Card.PresentPer = 0;
      }

      this.Card.Absent = (this.rowAttendanceData.filter((e: any) => this.AbsentCal_1.indexOf(this.common.ToLowerCase(e.AttendanceRemark)) >= 0).length)
        + (this.rowAttendanceData.filter((e: any) => this.AbsentCal_5.indexOf(this.common.ToLowerCase(e.AttendanceRemark)) >= 0).length / 2)
        - (this.rowAttendanceData.filter((e: any) => this.AbsentCal_M1.indexOf(this.common.ToLowerCase(e.AttendanceRemark)) >= 0).length)
        - (this.rowAttendanceData.filter((e: any) => this.AbsentCal_M5.indexOf(this.common.ToLowerCase(e.AttendanceRemark)) >= 0).length / 2);
      this.Card.AbsentPer = ((this.Card.Absent * 100) / this.Card.Total).toFixed(2);
      if (isNaN(this.Card.AbsentPer)) {
        this.Card.AbsentPer = 0;
      }

      this.Card.WeeklyOff = (this.rowAttendanceData.filter((e: any) => this.WeeklyOffCal_1.indexOf(this.common.ToLowerCase(e.AttendanceRemark)) >= 0).length);
      this.Card.Leave = (this.rowAttendanceData.filter((e: any) => this.LeaveCal_1.indexOf(this.common.ToLowerCase(e.AttendanceRemark)) >= 0).length)
        + (this.rowAttendanceData.filter((e: any) => this.LeaveCal_5.indexOf(this.common.ToLowerCase(e.AttendanceRemark)) >= 0).length / 2);
      this.Card.Holiday = (this.rowAttendanceData.filter((e: any) => this.HolidaysCal_1.indexOf(this.common.ToLowerCase(e.AttendanceRemark)) >= 0).length);

      this.isApply = false
      this.showGroupBack();
      this.isDisabled = false;
    } catch (e) {
      this.isApply = false;
      this.isDisabled = false;
    }
  }

  async showGroupBack() {
    this.isGrouping = true;
    await new Promise(f => setTimeout(f, 1000));
    try {
      //First, group the products by category
      let isGraph = false;
      this.filterData = this.rowAttendanceData.reduce((acc: any, curr) => {
        //let key = this.groupby.Designation ? curr['DesignationMasterID'] : this.groupby.Department ? curr['DepartmentMasterID'] : this.groupby.Branch ? curr['BranchId'] : this.groupby.Region ? curr['RegionMasterID'] : this.groupby.State ? curr['StateId'] : curr['DesignationMasterID'];
        //let keyName = this.groupby.Designation ? curr['DesignationName'] : this.groupby.Department ? curr['DepartmentName'] : this.groupby.Branch ? curr['BranchName'] : this.groupby.Region ? curr['RegionName'] : this.groupby.State ? curr['StateName'] : curr['DesignationName'];
        let key = '';
        let keyName = '';
        if (this.groupby.Designation) { key += curr['DesignationMasterID']; keyName += curr['DesignationName'] }
        if (this.groupby.Department) { key += curr['DepartmentMasterID']; keyName += curr['DepartmentName'] }
        if (this.groupby.Branch) { key += curr['BranchId']; keyName += curr['BranchName'] }
        if (this.groupby.Region) { key += curr['RegionMasterID']; keyName += curr['RegionName'] }
        if (this.groupby.State) { key += curr['StateId']; keyName += curr['StateName'] }


        if (!acc[key + '_' + keyName]) {
          acc[key + '_' + keyName] = [];
          isGraph = true;
        }
        acc[key + '_' + keyName].push(curr);
        return acc;
      }, {});

      if (isGraph && (this.mfilter.filterType == 0 || this.mfilter.filterType == 2 || this.mfilter.filterType == 3 || this.mfilter.filterType == 4)) {
        //let uniqDate = [...new Set(this.rowAttendanceData.map((item: any) => item.AttendanceDate))];

        let uniqDate = this.getDatesInRange(this.filter.FromDate, this.filter.ToDate);

        let AttendanceChartData = [] as any;
        AttendanceChartData.push(
          {
            label: 'Present',
            data: [],
            backgroundColor: ['#4ce2b0'],
          }
        );
        AttendanceChartData.push(
          {
            label: 'Absent',
            data: [],
            backgroundColor: ['#ff4c4c'],
          }
        );
        AttendanceChartData.push(
          {
            label: 'Weekoff',
            data: [],
            backgroundColor: ['#6A0DAD'],
          }
        );
        AttendanceChartData.push(
          {
            label: 'Leave',
            data: [],
            backgroundColor: ['#ffcc00'],
          }
        );
        AttendanceChartData.push(
          {
            label: 'Holiday',
            data: [],
            backgroundColor: ['#0096FF'],
          }
        );

        uniqDate.forEach(element => {
          const _datewise = this.rowAttendanceData.filter((e: any) => new Date(e.AttendanceDate).toISOString() == element.toISOString());
          AttendanceChartData[0].data.push((_datewise.filter((e: any) => this.PresentCal_1.indexOf(this.common.ToLowerCase(e.AttendanceRemark)) >= 0).length)
            + (_datewise.filter((e: any) => this.PresentCal_5.indexOf(this.common.ToLowerCase(e.AttendanceRemark)) >= 0).length / 2));
          AttendanceChartData[1].data.push((_datewise.filter((e: any) => this.AbsentCal_1.indexOf(this.common.ToLowerCase(e.AttendanceRemark)) >= 0).length)
            + (_datewise.filter((e: any) => this.AbsentCal_5.indexOf(this.common.ToLowerCase(e.AttendanceRemark)) >= 0).length / 2)
            - (_datewise.filter((e: any) => this.AbsentCal_M1.indexOf(this.common.ToLowerCase(e.AttendanceRemark)) >= 0).length)
            - (_datewise.filter((e: any) => this.AbsentCal_M5.indexOf(this.common.ToLowerCase(e.AttendanceRemark)) >= 0).length / 2))
          AttendanceChartData[2].data.push((_datewise.filter((e: any) => this.WeeklyOffCal_1.indexOf(this.common.ToLowerCase(e.AttendanceRemark)) >= 0).length));
          AttendanceChartData[3].data.push((_datewise.filter((e: any) => this.LeaveCal_1.indexOf(this.common.ToLowerCase(e.AttendanceRemark)) >= 0).length)
            + (_datewise.filter((e: any) => this.LeaveCal_5.indexOf(this.common.ToLowerCase(e.AttendanceRemark)) >= 0).length / 2));
          AttendanceChartData[4].data.push((_datewise.filter((e: any) => this.HolidaysCal_1.indexOf(this.common.ToLowerCase(e.AttendanceRemark)) >= 0).length));
        });
        this.AttendanceChartData = {
          labels: uniqDate.map(e => this.datepipe.transform(e, 'dd MMM yyyy')),
          datasets: AttendanceChartData
        };
      } else if (isGraph && (this.mfilter.filterType == 1)) {
        let ChartData = [] as any;
        ChartData.push(
          {
            label: 'Present',
            data: [this.Card.Present],
            backgroundColor: ['#4ce2b0'],
          }
        );
        ChartData.push(
          {
            label: 'Absent',
            data: [this.Card.Absent],
            backgroundColor: ['#ff4c4c'],
          }
        );
        ChartData.push(
          {
            label: 'Weekoff',
            data: [this.Card.WeeklyOff],
            backgroundColor: ['#6A0DAD'],
          }
        );
        ChartData.push(
          {
            label: 'Leave',
            data: [this.Card.Leave],
            backgroundColor: ['#ffcc00'],
          }
        );
        ChartData.push(
          {
            label: 'Holiday',
            data: [this.Card.Holiday],
            backgroundColor: ['#0096FF'],
          }
        );
        this.AttendanceChartData = {
          labels: [this.filter.MonthYear],
          datasets: ChartData,
        };
      } else {
        this.AttendanceChartData = {
          labels: [],
          datasets: []
        };
      }

      const Lb = [] as any
      const BPData = [] as any;
      const BAData = [] as any;
      const BWData = [] as any;
      const BLData = [] as any;
      const BHData = [] as any;
      [...new Set(this.rowAttendanceData.map((e: any) => e.BranchMasterID))].forEach((element: any) => {
        const _branchData = this.rowAttendanceData.filter((e: any) => e.BranchMasterID == element)
        Lb.push(_branchData[0]['BranchName']);
        BPData.push((_branchData.filter((e: any) => this.PresentCal_1.indexOf(this.common.ToLowerCase(e.AttendanceRemark)) >= 0).length)
          + (_branchData.filter((e: any) => this.PresentCal_5.indexOf(this.common.ToLowerCase(e.AttendanceRemark)) >= 0).length / 2));
        BAData.push((_branchData.filter((e: any) => this.AbsentCal_1.indexOf(this.common.ToLowerCase(e.AttendanceRemark)) >= 0).length)
          + (_branchData.filter((e: any) => this.AbsentCal_5.indexOf(this.common.ToLowerCase(e.AttendanceRemark)) >= 0).length / 2)
          - (_branchData.filter((e: any) => this.AbsentCal_M1.indexOf(this.common.ToLowerCase(e.AttendanceRemark)) >= 0).length)
          - (_branchData.filter((e: any) => this.AbsentCal_M5.indexOf(this.common.ToLowerCase(e.AttendanceRemark)) >= 0).length / 2))
        BWData.push((_branchData.filter((e: any) => this.WeeklyOffCal_1.indexOf(this.common.ToLowerCase(e.AttendanceRemark)) >= 0).length));
        BLData.push((_branchData.filter((e: any) => this.LeaveCal_1.indexOf(this.common.ToLowerCase(e.AttendanceRemark)) >= 0).length)
          + (_branchData.filter((e: any) => this.LeaveCal_5.indexOf(this.common.ToLowerCase(e.AttendanceRemark)) >= 0).length / 2));
        BHData.push((_branchData.filter((e: any) => this.HolidaysCal_1.indexOf(this.common.ToLowerCase(e.AttendanceRemark)) >= 0).length));
      });

      this.BranchChartData.labels = Lb;

      this.BranchChartData = {
        labels: Lb,
        datasets: [{
          label: 'Present',
          data: BPData,
          borderColor: ['#4ce2b0'],
          //pointBorderColor: ['#4ce2b0'],
          //pointBackgroundColor: ['#4ce2b0'],
          backgroundColor: ['#4ce2b0'],
          //fill:'start'
        },
        {
          label: 'Absent',
          data: BAData,
          borderColor: ['#ff4c4c'],
          //pointBorderColor: ['#ff4c4c'],
          //pointBackgroundColor: ['#ff4c4c'],
          backgroundColor: ['#ff4c4c'],
          //fill:'start'
        },
        {
          label: 'Weekoff',
          data: BWData,
          borderColor: ['#6A0DAD'],
          //pointBorderColor: ['#ff4c4c'],
          //pointBackgroundColor: ['#ff4c4c'],
          backgroundColor: ['#6A0DAD'],
          //fill:'start'
        },
        {
          label: 'Leave',
          data: BLData,
          borderColor: ['#ffcc00'],
          //pointBorderColor: ['#ff4c4c'],
          //pointBackgroundColor: ['#ff4c4c'],
          backgroundColor: ['#ffcc00'],
          //fill:'start'
        },
        {
          label: 'Holiday',
          data: BHData,
          borderColor: ['#0096FF'],
          //pointBorderColor: ['#ff4c4c'],
          //pointBackgroundColor: ['#ff4c4c'],
          backgroundColor: ['#0096FF'],
          //fill:'start'
        }
        ],
      };
      this.filterData = Object.values(isGraph ? this.filterData : []);
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
      this.isGrouping = false;
    } catch (e) {
      this.isDisabled = false;
      this.isGrouping = false;
    }
  }

  SelectDate(SelectType: string, BirthDate: any, JoiningDate: any) {
    return this.utility.SelectDate({ 'SelectType': SelectType, 'BirthDate': BirthDate, 'JoiningDate': JoiningDate, }).subscribe({
      next: (response) => {
        if (SelectType == 'RegistrationDate') {
          this.mfilter.TodayDate = moment(response.Table[0].RegistrationDate.RegistrationDate);
          this.mfilter.YesterdateDate = moment(response.Table[0].RegistrationDate.RegistrationDate).add(-1, 'day');
          this.mfilter.FromDate = {
            "year": this.mfilter.TodayDate.year(),
            "month": this.mfilter.TodayDate.month() + 1,
            "day": this.mfilter.TodayDate.date()
          };
        }
      },
      complete: () => {
        this.ESS_AttendanceDashboardGetData();
      },
      error: (error) => { },
    });
  }

  onNavigate(event: any) {
    this.mfilter.FromDate = {
      "year": event.next.year,
      "month": event.next.month,
      "day": 1
    }
  }

  getDatesInRange(startDate: any, endDate: any) {
    const date = new Date(startDate);
    const dates = [];
    while (date <= new Date(endDate)) {
      dates.push(new Date(date));
      date.setDate(date.getDate() + 1);
    }
    return dates;
  }

  Sitemanpower(Object: any) {
    return Object.length;
  }

  Present(Object: any) {
    return (Object.filter((e: any) => this.PresentCal_1.indexOf(this.common.ToLowerCase(e.AttendanceRemark)) >= 0).length)
      + (Object.filter((e: any) => this.PresentCal_5.indexOf(this.common.ToLowerCase(e.AttendanceRemark)) >= 0).length / 2);
  }

  Weekoff(Object: any) {
    return (Object.filter((e: any) => this.WeeklyOffCal_1.indexOf(this.common.ToLowerCase(e.AttendanceRemark)) >= 0).length);
  }

  Leave(Object: any) {
    return (Object.filter((e: any) => this.LeaveCal_1.indexOf(this.common.ToLowerCase(e.AttendanceRemark)) >= 0).length)
      + (Object.filter((e: any) => this.LeaveCal_5.indexOf(this.common.ToLowerCase(e.AttendanceRemark)) >= 0).length / 2);
  }

  Holiday(Object: any) {
    return (Object.filter((e: any) => this.HolidaysCal_1.indexOf(this.common.ToLowerCase(e.AttendanceRemark)) >= 0).length);
  }

  Absent(Object: any) {
    return (Object.filter((e: any) => this.AbsentCal_1.indexOf(this.common.ToLowerCase(e.AttendanceRemark)) >= 0).length)
      + (Object.filter((e: any) => this.AbsentCal_5.indexOf(this.common.ToLowerCase(e.AttendanceRemark)) >= 0).length / 2)
      - (Object.filter((e: any) => this.AbsentCal_M1.indexOf(this.common.ToLowerCase(e.AttendanceRemark)) >= 0).length)
      - (Object.filter((e: any) => this.AbsentCal_M5.indexOf(this.common.ToLowerCase(e.AttendanceRemark)) >= 0).length / 2);
  }

  AbsentPer(Object: any) {
    const abp = (this.Absent(Object) * 100) / this.Sitemanpower(Object);
    if (isNaN(abp)) {
      return 0;
    } else {
      return abp;
    }
  }

  ExcelDump(id: number) {
    this.excelData = [];
    if (id == 0) {
      
      this.filterData = Object.values(this.filterData.length > 0 ? this.filterData : []);
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
      this.isDisabled = false;

      this.excelData = JSON.parse(JSON.stringify(this.filterData));
      this.excelData.map((e: any) => { e[0].AbsentPer = this.AbsentPer(e).toFixed(2), e[0].TotalManpowerOfSite = this.Sitemanpower(e), e[0].P = this.Present(e), e[0].A = this.Absent(e), e[0].WeeklyOff = this.Weekoff(e), e[0].Leave = this.Leave(e), e[0].Holiday = this.Holiday(e) });
      this.excelData = this.excelData.map((e: any) => e[0]);
      this.excelData.forEach(function (x: any) {delete x.DailyAttendanceInOutId , delete x.SalaryMonthYear , delete x.EmpMasterID,delete x.EmpCode, delete x.FullName, delete x.StateMasterId, delete x.BranchMasterID, delete x.DesignationMasterID,delete x.DepartmentMasterID, delete x.ShiftMasterID, delete x.ShiftTitle, delete x.ShiftInTime, delete x.ShiftOutTime, delete x.RegionMasterID, delete x.InTime, delete x.OutTime, delete x.Regularization, delete x.AttendanceApprovalStatus,delete x.WorkingHour,delete x.EmpPhoto,delete x.DailyAttendancePhotoIn,delete x.DailyAttendancePhotoOut,delete x.ContactNo,delete x.ShiftGroupName,delete x.CheckInAddress,delete x.CheckOutAddress,delete x.IsInAttendanceMatch,delete x.IsOutAttendanceMatch,delete x.AttendanceMatchPercentage,delete x.OutAttendanceMatchPercentage, delete x.Latitude,delete x.Longitude,delete x.Altitude,delete x.LatitudeOut,delete x.LongitudeOut,delete x.AltitudeOut, delete x.ClientId, delete x.SiteId, delete x.SiteSupervisorId, delete x.ZoneId, delete x.ShiftId, delete x.AttendanceDate, delete x.PH, delete x.NH, delete x.ESS_ShiftGroupMasterId,delete x.AttendanceRemark });

      if (!this.groupby.State) {
        this.excelData.forEach(function (x: any) { delete x.StateName });
      } if (!this.groupby.Region) {
        this.excelData.forEach(function (x: any) { delete x.RegionName });
      } if (!this.groupby.Branch) {
        this.excelData.forEach(function (x: any) { delete x.BranchName });
      } if (!this.groupby.Client) {
        this.excelData.forEach(function (x: any) { delete x.ClientName });
      } if (!this.groupby.Site) {
        this.excelData.forEach(function (x: any) { delete x.SiteCode, delete x.SiteName });
      } if (!this.groupby.Department) {
        this.excelData.forEach(function (x: any) { delete x.DepartmentName });
      } if (!this.groupby.Designation) {
        this.excelData.forEach(function (x: any) { delete x.DesignationName });
      } if (!this.groupby.Site) {
        this.excelData.forEach(function (x: any) { delete x.SiteSupervisorName });
        this.excelData.forEach(function (x: any) { delete x.SiteStartDate });
        this.excelData.forEach(function (x: any) { delete x.SiteEndDate });
      }
    } else if (id == 1) {
      this.excelData = JSON.parse(JSON.stringify(this.filterEmpData));
      this.excelData.forEach(function (x: any) { delete x.SalaryMonthYear, delete x.DailyAttendanceInOutId, delete x.EmpMasterID, delete x.StateMasterId, delete x.BranchMasterID, delete x.DesignationMasterID, delete x.DepartmentMasterID, delete x.ShiftMasterID, delete x.RegionMasterID, delete x.RegionName, delete x.Leave, delete x.Regularization, delete x.AttendanceApprovalStatus, delete x.WorkingHour });
    }

    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    if (id == 0 || id == 1) {
      const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.excelData);
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    } else if (id == 2) {
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(document.getElementById("summarydatatable"));
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    }
    XLSX.writeFile(wb, 'ExcelSheet.xlsx');
  }

  async EmpTableFilter(Type: String, id: number) {
    this.isDisabled = true;
    await new Promise(f => setTimeout(f, 1000));
    if (this.rowAttendanceDataEmpMain.length > 0) {
      this.rowAttendanceDataEmp = this.rowAttendanceDataEmpMain.filter(e =>
        (this.mfilter.ShiftMasterID.length == 0 || this.mfilter.ShiftMasterID.indexOf(e['ShiftMasterID']) >= 0) &&
        (this.mfilter.StateMasterID.length == 0 || this.mfilter.StateMasterID.indexOf(e['StateMasterId']) >= 0) &&
        (this.mfilter.RegionMasterID.length == 0 || this.mfilter.RegionMasterID.indexOf(e['RegionMasterID']) >= 0) &&
        (this.mfilter.BranchMasterID.length == 0 || this.mfilter.BranchMasterID.indexOf(e['BranchMasterID']) >= 0) &&
        (this.mfilter.DesignationID.length == 0 || this.mfilter.DesignationID.indexOf(e['DesignationMasterID']) >= 0) &&
        (this.mfilter.DepartmentID.length == 0 || this.mfilter.DepartmentID.indexOf(e['DepartmentMasterID']) >= 0));

      this.filterEmpData = []

      if (Type == 'State') {
        this.filterEmpData = Object.values(this.rowAttendanceDataEmp.filter((e: any) => e.StateMasterId == id));
      } else if (Type == 'Region') {
        this.filterEmpData = Object.values(this.rowAttendanceDataEmp.filter((e: any) => e.RegionMasterID == id));
      } else if (Type == 'Branch') {
        this.filterEmpData = Object.values(this.rowAttendanceDataEmp.filter((e: any) => e.BranchMasterID == id));
      } else if (Type == 'Department') { //only for back
        this.filterEmpData = Object.values(this.rowAttendanceDataEmp.filter((e: any) => e.DepartmentMasterID == id));
      } else if (Type == 'Designation') { //only for back
        this.filterEmpData = Object.values(this.rowAttendanceDataEmp.filter((e: any) => e.DesignationMasterID == id));
      } else if (Type == 'Client') { //only for front
        this.filterEmpData = Object.values(this.rowAttendanceDataEmp.filter((e: any) => e.ClientId == id));
      } else if (Type == 'Site') { //only for front
        this.filterEmpData = Object.values(this.rowAttendanceDataEmp.filter((e: any) => e.SiteId == id));
      } else if (Type == 'Absent') { //only for front
        this.filterEmpData = Object.values(this.rowAttendanceDataEmp.filter((e: any) => (this.groupby.Site ? e.SiteId == id : this.groupby.Client ? e.ClientId == id : this.groupby.Branch ? e.BranchId == id : this.groupby.Region ? e.RegionMasterID == id : this.groupby.State ? e.StateId == id : e.SiteId == id) && e.A == 1));
      } else if (Type == 'Present') { //only for front
        this.filterEmpData = Object.values(this.rowAttendanceDataEmp.filter((e: any) => (this.groupby.Site ? e.SiteId == id : this.groupby.Client ? e.ClientId == id : this.groupby.Branch ? e.BranchId == id : this.groupby.Region ? e.RegionMasterID == id : this.groupby.State ? e.StateId == id : e.SiteId == id) && e.P == 1));
      }
      if (this.filterEmpData.length > 0) {
        try {
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.dtTriggerEmp.unsubscribe();
            this.dtTrigger.next(null);
            this.dtTriggerEmp.next(null);
            this.dtTriggerEmp.subscribe();
          });
          this.isDisabled = false;
        } catch (e) {
          this.isDisabled = false;
        }
      } else {
        this.toast.show({ message: 'Data not available..', type: toastTypeEnum.warning });
      }
    } else {
      if (this.mfilter.EmpDataLoad) {
        this.toast.show({ message: 'Data not available..', type: toastTypeEnum.dark });
      } else {
        this.toast.show({ message: 'Data Fetching in Process..', type: toastTypeEnum.dark });
      }
      this.isDisabled = false;
    }
  }

  CardCountFilter(type: string) {
    const modalRef = this.modalService.open(CardDetailComponent, { size: 'xl' });
    if (type == 'total') {
      modalRef.componentInstance.Datas.Title = 'All Employee Details';
      modalRef.componentInstance.Datas.Data = Object.values(this.rowAttendanceDataEmpMain.filter(e =>
        (this.mfilter.ShiftMasterID.length == 0 || this.mfilter.ShiftMasterID.indexOf(e['ShiftMasterID']) >= 0) &&
        (this.mfilter.StateMasterID.length == 0 || this.mfilter.StateMasterID.indexOf(e['StateMasterId']) >= 0) &&
        (this.mfilter.RegionMasterID.length == 0 || this.mfilter.RegionMasterID.indexOf(e['RegionMasterID']) >= 0) &&
        (this.mfilter.BranchMasterID.length == 0 || this.mfilter.BranchMasterID.indexOf(e['BranchMasterID']) >= 0) &&
        (this.mfilter.DesignationID.length == 0 || this.mfilter.DesignationID.indexOf(e['DesignationMasterID']) >= 0) &&
        (this.mfilter.DepartmentID.length == 0 || this.mfilter.DepartmentID.indexOf(e['DepartmentMasterID']) >= 0)));
    } else if (type == 'present') {
      modalRef.componentInstance.Datas.Title = 'Present Employee Details';
      modalRef.componentInstance.Datas.Data = Object.values(this.rowAttendanceDataEmpMain.filter(e =>
        (this.mfilter.ShiftMasterID.length == 0 || this.mfilter.ShiftMasterID.indexOf(e['ShiftMasterID']) >= 0) &&
        (this.mfilter.StateMasterID.length == 0 || this.mfilter.StateMasterID.indexOf(e['StateMasterId']) >= 0) &&
        (this.mfilter.RegionMasterID.length == 0 || this.mfilter.RegionMasterID.indexOf(e['RegionMasterID']) >= 0) &&
        (this.mfilter.BranchMasterID.length == 0 || this.mfilter.BranchMasterID.indexOf(e['BranchMasterID']) >= 0) &&
        (this.mfilter.DesignationID.length == 0 || this.mfilter.DesignationID.indexOf(e['DesignationMasterID']) >= 0) &&
        (this.mfilter.DepartmentID.length == 0 || this.mfilter.DepartmentID.indexOf(e['DepartmentMasterID']) >= 0)).filter((e: any) => this.PresentCal_1.indexOf(this.common.ToLowerCase(e.AttendanceRemark)) >= 0 || this.PresentCal_5.indexOf(this.common.ToLowerCase(e.AttendanceRemark)) >= 0));
    } else if (type == 'absent') {
      modalRef.componentInstance.Datas.Title = 'Absent Employee Details';
      modalRef.componentInstance.Datas.Data = Object.values(this.rowAttendanceDataEmpMain.filter(e =>
        (this.mfilter.ShiftMasterID.length == 0 || this.mfilter.ShiftMasterID.indexOf(e['ShiftMasterID']) >= 0) &&
        (this.mfilter.StateMasterID.length == 0 || this.mfilter.StateMasterID.indexOf(e['StateMasterId']) >= 0) &&
        (this.mfilter.RegionMasterID.length == 0 || this.mfilter.RegionMasterID.indexOf(e['RegionMasterID']) >= 0) &&
        (this.mfilter.BranchMasterID.length == 0 || this.mfilter.BranchMasterID.indexOf(e['BranchMasterID']) >= 0) &&
        (this.mfilter.DesignationID.length == 0 || this.mfilter.DesignationID.indexOf(e['DesignationMasterID']) >= 0) &&
        (this.mfilter.DepartmentID.length == 0 || this.mfilter.DepartmentID.indexOf(e['DepartmentMasterID']) >= 0)).filter((e: any) => this.AbsentCal_1.indexOf(this.common.ToLowerCase(e.AttendanceRemark)) >= 0 || this.AbsentCal_5.indexOf(this.common.ToLowerCase(e.AttendanceRemark)) >= 0));
    } else if (type == 'absent') {
      modalRef.componentInstance.Datas.Title = 'Absent Employee Details';
      modalRef.componentInstance.Datas.Data = Object.values(this.rowAttendanceDataEmpMain.filter(e =>
        (this.mfilter.ShiftMasterID.length == 0 || this.mfilter.ShiftMasterID.indexOf(e['ShiftMasterID']) >= 0) &&
        (this.mfilter.StateMasterID.length == 0 || this.mfilter.StateMasterID.indexOf(e['StateMasterId']) >= 0) &&
        (this.mfilter.RegionMasterID.length == 0 || this.mfilter.RegionMasterID.indexOf(e['RegionMasterID']) >= 0) &&
        (this.mfilter.BranchMasterID.length == 0 || this.mfilter.BranchMasterID.indexOf(e['BranchMasterID']) >= 0) &&
        (this.mfilter.DesignationID.length == 0 || this.mfilter.DesignationID.indexOf(e['DesignationMasterID']) >= 0) &&
        (this.mfilter.DepartmentID.length == 0 || this.mfilter.DepartmentID.indexOf(e['DepartmentMasterID']) >= 0)).filter((e: any) => this.AbsentCal_1.indexOf(this.common.ToLowerCase(e.AttendanceRemark)) >= 0 || this.AbsentCal_5.indexOf(this.common.ToLowerCase(e.AttendanceRemark)) >= 0));
    } else if (type == 'weeklyoff') {
      modalRef.componentInstance.Datas.Title = 'Week off Employee Details';
      modalRef.componentInstance.Datas.Data = Object.values(this.rowAttendanceDataEmpMain.filter(e =>
        (this.mfilter.ShiftMasterID.length == 0 || this.mfilter.ShiftMasterID.indexOf(e['ShiftMasterID']) >= 0) &&
        (this.mfilter.StateMasterID.length == 0 || this.mfilter.StateMasterID.indexOf(e['StateMasterId']) >= 0) &&
        (this.mfilter.RegionMasterID.length == 0 || this.mfilter.RegionMasterID.indexOf(e['RegionMasterID']) >= 0) &&
        (this.mfilter.BranchMasterID.length == 0 || this.mfilter.BranchMasterID.indexOf(e['BranchMasterID']) >= 0) &&
        (this.mfilter.DesignationID.length == 0 || this.mfilter.DesignationID.indexOf(e['DesignationMasterID']) >= 0) &&
        (this.mfilter.DepartmentID.length == 0 || this.mfilter.DepartmentID.indexOf(e['DepartmentMasterID']) >= 0)).filter((e: any) => this.WeeklyOffCal_1.indexOf(this.common.ToLowerCase(e.AttendanceRemark)) >= 0));
    } else if (type == 'leave') {
      modalRef.componentInstance.Datas.Title = 'Leave Employee Details';
      modalRef.componentInstance.Datas.Data = Object.values(this.rowAttendanceDataEmpMain.filter(e =>
        (this.mfilter.ShiftMasterID.length == 0 || this.mfilter.ShiftMasterID.indexOf(e['ShiftMasterID']) >= 0) &&
        (this.mfilter.StateMasterID.length == 0 || this.mfilter.StateMasterID.indexOf(e['StateMasterId']) >= 0) &&
        (this.mfilter.RegionMasterID.length == 0 || this.mfilter.RegionMasterID.indexOf(e['RegionMasterID']) >= 0) &&
        (this.mfilter.BranchMasterID.length == 0 || this.mfilter.BranchMasterID.indexOf(e['BranchMasterID']) >= 0) &&
        (this.mfilter.DesignationID.length == 0 || this.mfilter.DesignationID.indexOf(e['DesignationMasterID']) >= 0) &&
        (this.mfilter.DepartmentID.length == 0 || this.mfilter.DepartmentID.indexOf(e['DepartmentMasterID']) >= 0)).filter((e: any) => this.LeaveCal_1.indexOf(this.common.ToLowerCase(e.AttendanceRemark)) >= 0 || this.LeaveCal_5.indexOf(this.common.ToLowerCase(e.AttendanceRemark)) >= 0));
    } else if (type == 'holiday') {
      modalRef.componentInstance.Datas.Title = 'Holiday Employee Details';
      modalRef.componentInstance.Datas.Data = Object.values(this.rowAttendanceDataEmpMain.filter(e =>
        (this.mfilter.ShiftMasterID.length == 0 || this.mfilter.ShiftMasterID.indexOf(e['ShiftMasterID']) >= 0) &&
        (this.mfilter.StateMasterID.length == 0 || this.mfilter.StateMasterID.indexOf(e['StateMasterId']) >= 0) &&
        (this.mfilter.RegionMasterID.length == 0 || this.mfilter.RegionMasterID.indexOf(e['RegionMasterID']) >= 0) &&
        (this.mfilter.BranchMasterID.length == 0 || this.mfilter.BranchMasterID.indexOf(e['BranchMasterID']) >= 0) &&
        (this.mfilter.DesignationID.length == 0 || this.mfilter.DesignationID.indexOf(e['DesignationMasterID']) >= 0) &&
        (this.mfilter.DepartmentID.length == 0 || this.mfilter.DepartmentID.indexOf(e['DepartmentMasterID']) >= 0)).filter((e: any) => this.HolidaysCal_1.indexOf(this.common.ToLowerCase(e.AttendanceRemark)) >= 0));
    }
    modalRef.result.then(result => { });
  }

  CheckAllGroupBy() {
    if (this.groupby.Checkall) {
      this.groupby.State = true;
      this.groupby.Region = true;
      this.groupby.Branch = true;
      this.groupby.Client = true;
      this.groupby.Site = true;
      this.groupby.Department = true;
      this.groupby.Designation = true;
    } else {
      this.groupby.State = false;
      this.groupby.Region = false;
      this.groupby.Branch = false;
      this.groupby.Client = false;
      this.groupby.Site = false;
      this.groupby.Department = false;
      this.groupby.Designation = false;
    }
  }
}
